/**
 * @fileoverview FacilitySolve — AI Triage System Zustand store
 *
 * @author FacilityAI
 * @version 1.0.0
 */

import { create } from "zustand";
import type { TriageSessionListItem } from "@/services/facility-solve-triage-service";

interface FacilitySolveTriageState {
	sessions: TriageSessionListItem[];
	loading: boolean;
	statusFilter: string | undefined;
	setSessions: (sessions: TriageSessionListItem[]) => void;
	setLoading: (loading: boolean) => void;
	setStatusFilter: (status: string | undefined) => void;
}

export const useFacilitySolveTriageStore = create<FacilitySolveTriageState>((set) => ({
	sessions: [],
	loading: false,
	statusFilter: undefined,

	setSessions: (sessions) => set({ sessions }),
	setLoading: (loading) => set({ loading }),
	setStatusFilter: (statusFilter) => set({ statusFilter }),
}));
